<svg xmlns="http://www.w3.org/2000/svg" x="0px"
y="0px" enable-background="new 0 0 24 24" xml:space="preserve" viewBox="0 0 24 24">
    <g>
        <path fill="currentColor" d="M12 2.1c-5.5 0-9.9 4.4-9.9 9.9 0 5.5 4.4 9.9 9.9 9.9 5.5 0 9.9-4.4 9.9-9.9C21.9 6.5 17.5 2.1 12 2.1zM12 20.1c-4.5 0-8.1-3.6-8.1-8.1 0-4.5 3.6-8.1 8.1-8.1 4.5 0 8.1 3.6 8.1 8.1C20.1 16.5 16.5 20.1 12 20.1z"/>
        <path fill="currentColor" d="M11.8 6.7c-2.5 0-3.2 2.2-3.2 2.2L10 9.7c0 0 0.3-0.8 0.9-1.2 0.5-0.4 1.6-0.6 2.2 0.1 0.7 0.9-0.2 1.6-1.1 2.7C11 12.5 11 15 11 15h2c0 0 0.1-2.3 1-3.4 0.6-0.7 1.4-1.3 1.4-2.5S14.3 6.7 11.8 6.7z"/>
        <rect fill="currentColor" x="11" y="16" width="2" height="2"/>
    </g>
</svg>